import { Part, PartProduct } from '@entities/Product';
import { PopupRemainder } from '../PopupRemainder';
import { IPopup } from '../TypeProps';

import styles from './PopupConditionV2.module.scss';

export const PopupConditionV2 = ({ part, allQuantity, max, countLimit }: IPopup) => (
  <>
    {[Part.Tyres, PartProduct.Tyres, Part.Disks, PartProduct.Disks].includes(part) && countLimit && (
      <PopupRemainder
        className={styles.TooltipPopup}
        text={
          <p>
            {allQuantity < 4 || max < 4 ? 'Товар заканчивается.' : (allQuantity >= 4 || max >= 4) && 'Нельзя купить больше.'}
            <br />В наличии только {allQuantity || max} шт.
          </p>
        }
      />
    )}
  </>
);
